import $ from 'jquery';

$('#contact-form').each(function() {

    var $form = $(this);
    
    $form.on('submit', e => {

        e.preventDefault();

        var data = $form.serializeArray(),
            url = $form.attr('action');

        $.post(url, data, result => {
            
            $form.replaceWith(`<div class="form-success">
                <h3>Vielen Dank für Ihre Anfrage.</h3>
                <p>Ich habe Ihre Nachricht erhalten und bemühe mich schnellstmöglich um eine Antwort.</p>
            </div>`);

            window.setTimeout(e => {
                $('html, body').animate({
                    scrollTop: $('.form-success').offset().top - 300
                }, 500)
            }, 0);

        });


    });

});